import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import config from '../config';
import '../styles/resetPassword.css';

const ResetPassword = () => {
    const { uidb64, token } = useParams();
    const [contactMethod, setContactMethod] = useState('email');
    const [contactValue, setContactValue] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (password !== confirmPassword) {
            setError('Les mots de passe ne correspondent pas.');
            return;
        }

        try {
            const response = await fetch(`${config.backendUrl}/users/reset-password/${uidb64}/${token}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ contact_method: contactMethod, contact_value: contactValue, code: verificationCode, password }),
            });

            if (response.ok) {
                setMessage('Le mot de passe a été réinitialisé avec succès.');
                setTimeout(() => {
                    navigate('/login');
                }, 3000); // Redirect to login page after 3 seconds
            } else {
                const data = await response.json();
                setError(data.error || 'Une erreur est survenue. Veuillez réessayer.');
            }
        } catch (error) {
            setError('Une erreur est survenue. Veuillez réessayer.');
        }
    };

    return (
        <div>
            <div className="reset-password-container">
                <h2 className="reset-password-title">Réinitialiser le mot de passe</h2>
                <form onSubmit={handleSubmit} className="reset-password-form">
                    <div className="input-group">
                        <label>
                            <input
                                type="radio"
                                name="contactMethod"
                                value="email"
                                checked={contactMethod === 'email'}
                                onChange={() => setContactMethod('email')}
                            />
                            Email
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="contactMethod"
                                value="sms"
                                checked={contactMethod === 'sms'}
                                onChange={() => setContactMethod('sms')}
                            />
                            SMS
                        </label>
                    </div>
                    <div className="input-group">
                        <label htmlFor="contactValue">{contactMethod === 'email' ? 'Email' : 'Numéro de téléphone'}</label>
                        <input
                            type={contactMethod === 'email' ? 'email' : 'text'}
                            name="contactValue"
                            id="contactValue"
                            value={contactValue}
                            onChange={(e) => setContactValue(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="verificationCode">Code de vérification</label>
                        <input
                            type="text"
                            name="verificationCode"
                            id="verificationCode"
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Nouveau mot de passe</label>
                        <input
                            type="password"
                            name="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="confirmPassword">Confirmer le nouveau mot de passe</label>
                        <input
                            type="password"
                            name="confirmPassword"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    {message && <p className="success-message">{message}</p>}
                    {error && <p className="request-password-reset-error-message">{error}</p>}
                    <button type="submit" className="reset-password-button">Réinitialiser le mot de passe</button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;